let _ = t => t,
  _t;
import { useCallback, useMemo, useRef, useState } from 'react';
import debounce from 'react-utils/debounce';
import { device } from '../constants/StyledComponentConstants';
// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from '../hooks/useMediaQuery';
// @ts-expect-error Could not find a declaration file for module
import Scrollbar from './Scrollbar';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CarouselOuter = styledWithTheme.div(_t || (_t = _`
  inline-size: calc(
    100% +
      max(
        ${0},
        ${0}
      ) * 2
  );
  margin-inline-start: calc(
    max(
        ${0},
        ${0}
      ) * -1
  );
  padding-inline-start: calc(
    max(
      ${0},
      ${0}
    )
  );
  padding-inline-end: calc(
    max(
      ${0},
      ${0}
    )
  );
  overflow-x: auto;
  scrollbar-color: transparent transparent;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    background: transparent;
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent !important;
  }
`), ({
  pageMargin,
  theme
}) => theme.space[pageMargin], ({
  fixedMargin
}) => fixedMargin ? '0px' : '(100vw - 1296px)', ({
  pageMargin,
  theme
}) => theme.space[pageMargin], ({
  fixedMargin
}) => fixedMargin ? '0px' : '(100vw - 1296px) / 2', ({
  pageMargin,
  theme
}) => theme.space[pageMargin], ({
  fixedMargin
}) => fixedMargin ? '0px' : '(100vw - 1296px) / 2', ({
  pageMargin,
  theme
}) => theme.space[pageMargin], ({
  fixedMargin
}) => fixedMargin ? '0px' : '(100vw - 1296px) * 1.5');
const Carousel = ({
  carouselProps,
  children,
  fixedMargin,
  onClosestChildChange,
  pageMargin
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const [carouselContainerRef, setCarouselContainerRef] = useState(null);
  const [childrenRefs, setChildrenRefs] = useState([]);
  const handleCarouselScroll = useCallback(() => debounce(() => {
    if (!carouselContainerRef || !childrenRefs) {
      return;
    }
    let previousClosest = 0;
    for (let i = 0; i < childrenRefs.length; i++) {
      const el = childrenRefs[i];
      const previousClosestEl = childrenRefs[previousClosest];
      if (!el || !previousClosestEl) {
        continue;
      }
      if (Math.abs(carouselContainerRef.getBoundingClientRect().x - el.getBoundingClientRect().x) <= Math.abs(carouselContainerRef.getBoundingClientRect().x - previousClosestEl.getBoundingClientRect().x)) {
        previousClosest = i;
      } else {
        break;
      }
    }
    onClosestChildChange === null || onClosestChildChange === void 0 || onClosestChildChange(previousClosest);
  }, 500), [carouselContainerRef, childrenRefs, onClosestChildChange]);
  const childrenWithRefs = useMemo(() => {
    const refs = [];
    const returnableChildren = children.map((child, index) => {
      return /*#__PURE__*/_jsx(View, {
        marginInlineEnd: index === children.length - 1 ? undefined : '400',
        ref: ref => refs[index] = ref,
        children: child
      }, index);
    });
    setChildrenRefs(refs);
    return returnableChildren;
  }, [children]);
  const containerRef = useRef(null);
  const defaultMargin = isMobile ? '300' : '1100';
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(CarouselOuter, {
      fixedMargin: fixedMargin,
      pageMargin: pageMargin || defaultMargin,
      ref: containerRef,
      children: /*#__PURE__*/_jsx(TFlex, Object.assign({
        inlineSize: "max-content",
        maxInlineSize: "unset",
        onScroll: handleCarouselScroll,
        paddingBlockEnd: "400",
        paddingBlockStart: "25",
        paddingInlineStart: "25",
        ref: ref => setCarouselContainerRef(ref)
      }, carouselProps, {
        children: childrenWithRefs
      }))
    }), /*#__PURE__*/_jsx(Scrollbar, {
      scrollableContentRef: containerRef
    })]
  });
};
export default Carousel;